import * as React from 'react';
import type { ReactNode } from 'react';
import { Collapse } from '~/Partials/Collapse/Collapse';
import styles from './NotificationBannerBase.module.css';

interface NotificationBannerBaseProps {
    children: ReactNode;
    isOpen: boolean;
}

export const NotificationBannerBase: React.FC<React.PropsWithChildren<NotificationBannerBaseProps>> = props => {
    const { children, isOpen } = props;

    return (
        <Collapse isOpen={isOpen} className={styles.NotificationBannerBase}>
            <div className={styles.Inner}>{children}</div>
        </Collapse>
    );
};
